import { DatePicker, Spin } from "antd";
import dayjs from "dayjs";
import i18next from "i18next";
import { useState } from "react";
import { Trans } from "react-i18next";
import styled from "styled-components";
import { StyledButton } from "./StyledElements";

const { RangePicker } = DatePicker;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
`;
const CustomRangePicker = styled(RangePicker)`
  height: fit-content;
`;

export const dateRangeModalProps = {
  centered: true,
  title: i18next.t("select_date_range"),
  width: "35%",
  footer: null,
  destroyOnHidden: true
};

const DateRangeModal = (props) => {
  const {
    buttonTitle = "",
    handleOnClick = () => {},
    onSelectDates = () => {},
    isLoading = false
  } = props;
  const [selectedDates, setSelectedDates] = useState([
    dayjs().startOf("month"),
    dayjs()
  ]);

  return (
    <Container>
      <CustomRangePicker
        disabledDate={(currentDate) => {
          const threeMonthsAgoDate = dayjs()
            .subtract(6, "months")
            .startOf("month");
          const todayDate = dayjs().endOf("day");
          return currentDate < threeMonthsAgoDate || currentDate > todayDate;
        }}
        format="DD/MM/YYYY"
        defaultValue={[dayjs().startOf("month"), dayjs()]}
        onChange={(a) => {
          setSelectedDates(a);
          onSelectDates();
        }}
      />
      <StyledButton type="primary" onClick={() => handleOnClick(selectedDates)}>
        {isLoading && <Spin size="small" />}
        <Trans i18nKey={buttonTitle || "done"} />
      </StyledButton>
    </Container>
  );
};

export default DateRangeModal;
